import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner, Alert, Pagination, Button, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { MyApi } from "../MyApi";

export default function FeedbackPage() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 6; // testimonials per page

  const fetchTestimonials = async (page = 1) => {
    setLoading(true);
    try {
      const res = await axios.get(MyApi.BASE_URL + "get-testimonials", {
        headers: { Authorization: MyApi.SECRET_KEY },
        params: { page, limit },
      });

      if (res.data.status && res.data.testimonials) {
        setTestimonials(res.data.testimonials);
        setTotalPages(res.data.total_pages || 1);
        setError("");
      } else {
        setTestimonials([]);
        setError("No Reviews found");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to fetch Reviews");
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials(currentPage);
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPagination = () => {
    let items = [];

    // Previous arrow
    items.push(
      <Pagination.Prev
        key="prev"
        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    // Page numbers
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    // Next arrow
    items.push(
      <Pagination.Next
        key="next"
        onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return <Pagination className="justify-content-center">{items}</Pagination>;
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (error) {
    return (
      <>
         <div className="BreadcrumbStyle">
        <Container>
        <Row className="align-items-center">
          <Col>
             <h1>Customer Reviews</h1>
              <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Reviews</Breadcrumb.Item>
              </Breadcrumb>
          </Col>
           <Col xs="12" md="auto" className="text-md-end text-start">
            <Link to="/feedback-form">
              <Button className="button_style">Post Feedback</Button>
            </Link>
          </Col>
        </Row>
        </Container>
      </div>
      <Container className="py-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
      </>
    );
  }

  return (
    <>
 <div className="BreadcrumbStyle">
        <Container>
        <Row className="align-items-center">
          <Col>
             <h1>Customer Reviewss</h1>
              <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Reviews</Breadcrumb.Item>
              </Breadcrumb>
          </Col>
           <Col xs="12" md="auto" className="text-md-end text-start">
            <Link to="/feedback-form">
              <Button className="button_style">Post Feedback</Button>
            </Link>
          </Col>
        </Row>
        </Container>
      </div>
    <Container className="py-5">
      {/* Post Feedback Button */}  
      <Row>
        {testimonials.map((t) => (
          <Col md={6} lg={6} key={t.id} className="mb-4">
            <Card className="border-0 shadow h-100">
  <Row className="g-0">
    {/* IMAGE COLUMN */}
    {t.image_url && (
      <Col
        xs={12}
        md={4}
        className="d-flex align-items-stretch"
      >
        <img
          src={t.image_url}
          alt={t.uname}
          className="img-fluid w-100 h-100 object-fit-cover rounded-start"
        />
      </Col>
    )}

    {/* CONTENT COLUMN */}
    <Col xs={12} md={t.image_url ? 8 : 12}>
      <Card.Body>
        <Card.Title>{t.uname}</Card.Title>

        {t.tsubject && (
          <Card.Subtitle className="mb-2 text-muted">
            {t.tsubject}
          </Card.Subtitle>
        )}
<Card.Text>
          Rating: {"⭐".repeat(t.rating)}
        </Card.Text>
        <Card.Text>{t.feedback}</Card.Text>

        

        {/* Mobile masked (last 2 digits only) */}
        {/* {t.mobileno && (
          <Card.Text>
            Mobile: {"****" + t.mobileno.slice(-2)}
          </Card.Text>
        )} */}

        {/* Email masked (first 2 + last 4) */}
        {/* {t.email && (
          <Card.Text>
            Email:{" "}
            {t.email.slice(0, 2) +
              "****" +
              t.email.slice(-4)}
          </Card.Text>
        )} */}
      </Card.Body>
    </Col>
  </Row>
</Card>

          </Col>
        ))}
      </Row>

      {totalPages > 1 && renderPagination()}
    </Container>
    </>
  );
}
